import { IconProps } from "./icon.type";

export function IcDeleteWarning({ ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      {...props}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 0C15.523 0 20 4.478 20 10C20 15.522 15.523 20 10 20C4.477 20 0 15.522 0 10C0 4.478 4.477 0 10 0ZM10 1.667C5.405 1.667 1.667 5.405 1.667 10C1.667 14.595 5.405 18.333 10 18.333C14.595 18.333 18.333 14.595 18.333 10C18.333 5.405 14.595 1.667 10 1.667ZM9.99866 12.5022C10.5502 12.5022 10.9973 12.9494 10.9973 13.5009C10.9973 14.0524 10.5502 14.4996 9.99866 14.4996C9.44712 14.4996 9 14.0524 9 13.5009C9 12.9494 9.44712 12.5022 9.99866 12.5022ZM9.99446 5C10.3742 4.9997 10.6882 5.2816 10.7381 5.64764L10.7451 5.7494L10.7487 10.251C10.749 10.6652 10.4135 11.0013 9.99926 11.0016C9.61957 11.0019 9.30555 10.72 9.25559 10.354L9.24866 10.2522L9.24506 5.7506C9.24473 5.33639 9.58025 5.00033 9.99446 5Z"
        fill="#FF9500"
      />
    </svg>
  );
}
